module.exports = __webpack_public_path__ + "static/media/SM-MT2-TRIAL-if-wrong.abc4ab12.mp3";